import canguardNotificationsApi from './canguardNotificationsApi';

interface Announcement {
	ItemID: number;
	Title: string;
	Description: string;
	MoreLink: string | null;
	CreatedDate: string | null;
	ExpireDate: string | null;
}

export const getAnnouncementsV4 = async (): Promise<Announcement[]> => {
	try {
		const response = await canguardNotificationsApi.get<{ success: boolean; data: Announcement[] }>(
			'/',
		);
		return response.data?.data ?? [];
	} catch (error) {
		console.error('[getAnnouncementsV4/getAnnouncementsV4] Failed:', error);
		throw error;
	}
};
